import React, { useEffect, useState } from "react";

const MovingComponent = ({
    children,
    startPosition = 20,
    direction = "up",
    speedFactor = 5,
}) => {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    let translateY = 0;

    if (direction === "up") {
        translateY =
            startPosition - scrollY / speedFactor < -350
                ? -350
                : startPosition - scrollY / speedFactor;
    } else if (direction === "down") {
        translateY =
            Math.min(
                startPosition + scrollY / speedFactor,
                window.innerHeight
            ) > 350
                ? 350
                : Math.min(
                      startPosition + scrollY / speedFactor,
                      window.innerHeight
                  ); // Обмеження знизу
    }

    return (
        <div
            className="moving-component"
            style={{ transform: `translateY(${translateY}px)` }}
        >
            {children}
        </div>
    );
};

export default MovingComponent;
